import { render } from "./FacetItemColor.vue?vue&type=template&id=43ea90ed"
import script from "./FacetItemColor.vue?vue&type=script&lang=js"
export * from "./FacetItemColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__